import React, { useState, useEffect } from 'react';
import './IntroScreens.css';
import { useNavigate } from 'react-router-dom';

const IntroScreens = ({ onFinish }) => {
  const navigate = useNavigate();
  const [currentScreen, setCurrentScreen] = useState(0);
  const [isExiting, setIsExiting] = useState(false);
  const [direction, setDirection] = useState('next');

  const screens = [
    {
      id: 1,
      icon: '🏥',
      title: 'Find Trusted Healthcare',
      description: 'Discover verified doctors, hospitals, and clinics near you with real-time availability',
      color: '#4f46e5',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      id: 2,
      icon: '📅',
      title: 'Book Appointments Instantly',
      description: 'Schedule appointments with your preferred doctors in just a few taps',
      color: '#06b6d4',
      gradient: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)'
    },
    {
      id: 3,
      icon: '💳',
      title: 'Secure & Easy Payments',
      description: 'Pay securely online and get instant booking confirmations',
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    }
  ];

  useEffect(() => {
    // Check if user has seen intro before
    const hasSeenIntro = localStorage.getItem('hasSeenIntro');
    if (hasSeenIntro) {
      // Skip intro if already seen
      if (onFinish) onFinish();
    }
  }, [onFinish]);

  const handleNext = () => {
    if (currentScreen < screens.length - 1) {
      setDirection('next');
      setCurrentScreen(currentScreen + 1);
    } else {
      handleFinish();
    }
  };

  const handlePrevious = () => {
    if (currentScreen > 0) {
      setDirection('prev');
      setCurrentScreen(currentScreen - 1);
    }
  };

  const handleSkip = () => {
    handleFinish();
  };

  const handleFinish = () => {
    setIsExiting(true);
    localStorage.setItem('hasSeenIntro', 'true');
    setTimeout(() => {
      navigate('/mobile/home');
    }, 500);
  };

  const handleDotClick = (index) => {
    setDirection(index > currentScreen ? 'next' : 'prev');
    setCurrentScreen(index);
  };

  // Touch handling for swipe gestures
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && currentScreen < screens.length - 1) {
      handleNext();
    }
    if (isRightSwipe && currentScreen > 0) {
      handlePrevious();
    }
  };

  return (
    <div className={`intro-screens ${isExiting ? 'fade-out' : ''}`}>
      {/* Background with dynamic gradient */}
      <div 
        className="intro-background" 
        style={{ background: screens[currentScreen].gradient }}
      ></div>

      {/* Skip Button */}
      <button className="intro-skip-btn" onClick={handleSkip}>
        Skip
      </button>

      {/* Screens Container */}
      <div 
        className="intro-screens-container"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {screens.map((screen, index) => (
          <div
            key={screen.id}
            className={`intro-screen ${
              index === currentScreen ? 'active' : ''
            } ${
              index < currentScreen ? 'left' : ''
            } ${
              index > currentScreen ? 'right' : ''
            } ${direction}`}
          >
            {/* Icon Container */}
            <div className="intro-icon-container">
              <div className="intro-icon-bg">
                <div className="intro-icon-circle"></div>
                <div className="intro-icon-circle-2"></div>
              </div>
              <div className="intro-icon">{screen.icon}</div>
            </div>

            {/* Content */}
            <div className="intro-content">
              <h2 className="intro-title">{screen.title}</h2>
              <p className="intro-description">{screen.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination Dots */}
      <div className="intro-pagination">
        {screens.map((screen, index) => (
          <button
            key={screen.id}
            className={`intro-dot ${index === currentScreen ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to screen ${index + 1}`}
          >
            <span></span>
          </button>
        ))}
      </div>

      {/* Navigation Buttons */}
      <div className="intro-navigation">
        {currentScreen > 0 && (
          <button className="intro-btn intro-btn-back" onClick={handlePrevious}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
        )}
        
        <button 
          className="intro-btn intro-btn-next" 
          onClick={handleNext}
          style={{ marginLeft: currentScreen === 0 ? 'auto' : '0' }}
        >
          {currentScreen === screens.length - 1 ? 'Get Started' : 'Next'}
          {currentScreen < screens.length - 1 && (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default IntroScreens;

